// extracted by mini-css-extract-plugin
export var playButton = "YouTubeVideo-module--playButton--FMLwS";
export var poster = "YouTubeVideo-module--poster--rv0CG";
export var text = "YouTubeVideo-module--text--B8zUP";
export var videoWrapper = "YouTubeVideo-module--videoWrapper--Oa6vT";